var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fileSelector',{attrs:{"fileType":"image"},on:{"finish":_vm.onFinish}})
}
var staticRenderFns = []

export { render, staticRenderFns }